import { sendAdminRequest, sendRequest } from '../api/websocketApi';
import { LabProcessStatus } from '../hooks/useKits';
import useStore from '../store/store';

interface AddKitParams {
    memberId: number;
    kitTypeId: number;
    sampleId?: string;
    nickname?: string;
    isAdmin?: boolean;
}

interface APIResponse {
    success: boolean;
    errCode?: 'invalid_token' | 'auth_failed' | 'access_denied';
    errDetails?: string;
    kitId?: number;
    sampleRegistrationDate?: Date;
    labProcessStatus?: LabProcessStatus;
    insertionDate?: Date;
}

const AddKit = ({
    memberId,
    kitTypeId,
    sampleId,
    nickname,
    isAdmin = false,
}: AddKitParams) => {
    const setFormError = useStore.getState().setFormError;
    const setIsLoading = useStore.getState().setIsLoading;

    setIsLoading(true);
    if (isAdmin) {
        sendAdminRequest(
            {
                endpoint: '/kit/add',
                body: {
                    memberId,
                    kitTypeId,
                    sampleId,
                    nickname,
                },
            },
            (data: APIResponse) => {
                const { success, kitId, errCode, errDetails } = data;
                if (success && kitId) {
                    setIsLoading(false);
                } else if (!success && errCode) {
                    setIsLoading(false);
                    setFormError('');
                    setTimeout(() => setFormError(errCode), 0);
                    console.error(errCode);
                    if (errDetails) console.error(errDetails);
                }
            }
        );
    } else {
        sendRequest(
            {
                endpoint: '/kit/add',
                body: {
                    memberId,
                    kitTypeId,
                    sampleId,
                    nickname,
                },
            },
            (data: APIResponse) => {
                const { success, kitId, errCode, errDetails } = data;
                if (success && kitId) {
                    setIsLoading(false);
                } else if (!success && errCode) {
                    setIsLoading(false);
                    setFormError('');
                    setTimeout(() => setFormError(errCode), 0);
                    console.error(errCode);
                    if (errDetails) console.error(errDetails);
                }
            }
        );
    }
};

export default AddKit;
